
import { searchEntities } from '../../store/selectors/search';

export const selectWalkthroughSuites = state => searchEntities(state, 'walkthroughtSuites', []);
